import { IHeaderParams } from "ag-grid-community";

import { useReportContext } from "../report-context";

import { ReportColumn } from "@/types/evaluate";
import HeaderCell from "@/components/Evaluate/TableComponents/Header";

interface ReportHeaderRendererProps extends IHeaderParams {
  displayName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  column: any;
}

export const ReportHeaderRenderer = ({ displayName, column }: ReportHeaderRendererProps) => {
  const reportContext = useReportContext();

  const columnId = column.getColDef().field;
  const reportColumn = reportContext.sortedColumns.find(
    (col: ReportColumn) => String(col.id) === columnId,
  );

  if (!reportColumn) {
    return (
      <div className="flex h-full w-full items-center px-3 font-medium text-gray-900">
        <span className="truncate">{displayName}</span>
      </div>
    );
  }

  return (
    <HeaderCell
      column={reportColumn}
      reportId={reportContext.reportId}
      availableColumns={reportContext.sortedColumns}
      isEditable={reportContext.isEditable}
      isDraft={!reportColumn.id || reportColumn.id === -999}
    />
  );
};

export default ReportHeaderRenderer;
